import React from "react";
import { map } from "lodash";

import { fontFamily } from "./styles";

const GenericTable = ({ header, rows }) => (
  <div style={{ marginBottom: "1.5em" }}>
    <table
      style={{
        width: "100%",
        fontFamily,
        fontSize: "16px"
      }}
    >
      <tbody>
        <tr
          style={{
            color: "#2F9CA3",
            fontWeight: "800",
            fontSize: "18px",
            textAlign: "center"
          }}
        >
          {map(header, (item, idx) => (
            <td key={idx} style={item.highlighted ? {} : { color: "#000000" }}>
              {item.name}
            </td>
          ))}
        </tr>
        {map(rows, (row, idx) => (
          <tr style={{ textAlign: "center" }} key={idx}>
            {map(row, (item, itemIdx) => (
              <td key={itemIdx}>{item}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default GenericTable;



// WEBPACK FOOTER //
// ./src/components/analysis/GenericTable.js